export { default as LocaleContext } from './LocaleContext';
export { usePageLocale } from './LocaleContext';
